module.exports = __webpack_public_path__ + "static/media/jt2.b88e9f93.png";